import { useContext } from 'react';
import { useSelector } from 'react-redux';
import MetricsInspectionContext from '../../../state/context';
import { StyledCell } from '../Table.style';
import AuthorsCell from '../common/cells/AutorsCell';
import NameCell from '../common/cells/NameCell';
import { contributorsByIdSelector } from 'state/selectors/contributors';
import StateCell from '../common/cells/StateCell';
import { PRS_MODEL, PRS_TABLE_MODEL } from './prs.model';
import PRMetricValueCell from '../common/cells/PRMetricValueCell';
import { ACTIVITY_TYPES } from '../../../state/state.utils';
import { mapActivityTypeToEntityKey } from '../../../Charts/ScatterChart/useFetchData/entities.utils';
import AdditionalValueCell from '../common/cells/AdditionalValueCell';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';

const usePRsRows = ({ data } = {}) => {
  const {
    state: { hoveredPoint, widget }
  } = useContext(MetricsInspectionContext);
  const highlightId =
    hoveredPoint?.extraData?.[mapActivityTypeToEntityKey[ACTIVITY_TYPES.PRS]];
  const { getSettingOrDefinitionValue } = useSettingsService();
  const prMetricsPerBranchContributorsEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.prMetricsPerBranchContributorsEnabled
  });
  const contributorsById = useSelector(contributorsByIdSelector);
  const prs = data?.items || [];

  const rows = prs.map(pr => {
    const id = pr?.id;
    const repoName = pr?.[PRS_MODEL.REPO_NAME] || '';

    const contributorIds = prMetricsPerBranchContributorsEnabled
      ? pr?.[PRS_MODEL.EFFECTIVE_CONTRIBUTOR_IDS]
      : [pr?.[PRS_MODEL.ISSUER_ID]];

    const contributors = contributorIds
      .map(contributorId => contributorsById[contributorId])
      .filter(Boolean);

    const state = pr?.[PRS_MODEL.STATE];

    return {
      styles: { highlight: id === highlightId },
      [PRS_TABLE_MODEL.TITLE_CELL]: (
        <NameCell
          name={pr?.[PRS_MODEL.TITLE]}
          url={pr?.[PRS_MODEL.PR_URL]}
          widgetName={widget?.name}
          element={'PRs'}
        />
      ),
      [PRS_TABLE_MODEL.REPO_CELL]: <StyledCell>{repoName}</StyledCell>,
      [PRS_TABLE_MODEL.ISSUER_CELL]: (
        <AuthorsCell contributors={contributors} />
      ),
      [PRS_TABLE_MODEL.STATE_CELL]: <StateCell state={state} />,
      [PRS_TABLE_MODEL.METRIC_VALUE_CELL]: <PRMetricValueCell pr={pr} />,
      [PRS_TABLE_MODEL.COMMENT_CELL]: (
        <AdditionalValueCell pr={pr} value_key='comment_count' />
      ),
      [PRS_TABLE_MODEL.REVIEW_CELL]: (
        <AdditionalValueCell pr={pr} value_key='reviews_count' />
      )
    };
  });

  return rows;
};

export default usePRsRows;
